import locationIcon from '../../../icons/location_icon'
import addIcon from '../../../icons/add_icon'
import pencilIcon from '../../../icons/pencil_icon'
import logoutIcon from '../../../icons/logout_icon'
import arrowShortIcon from '../../../icons/arrow_short_icon'

export const ICON_COMPONENTS = {
  location: locationIcon,
  pencil: pencilIcon,
  add: addIcon,
  logout: logoutIcon,
  arrowShort: arrowShortIcon
}
